import axios from "axios";
import { JWT } from "../config/constants";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8081/api";

// Export base URL for static files (without /api)
// Remove /api and ensure no trailing slash
export const API_BASE_URL = API_URL.replace(/\/api\/?$/, "");
export const API_HOST = API_URL;

// Create axios instance
const apiClient = axios.create({
  baseURL: API_URL,
});

// Add request interceptor to include JWT token in headers
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(JWT.TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("Login Failed: Please log in again.");
    }

    // Log outgoing requests for debugging (only in development)
    if (process.env.NODE_ENV === "development") {
      console.log(
        `🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`,
        {
          hasAuth: !!config.headers.Authorization,
          contentType: config.headers["Content-Type"],
        },
      );
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor to handle 401 Unauthorized
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const currentPath = window.location.pathname;

    // 🔥 daftar halaman public
    const publicPaths = ["/login", "/register"];

    const isPublic = publicPaths.some((path) =>
      currentPath.startsWith(path)
    );

    if (status === 401) {
      // Debug log (optional)
      console.warn("401 Unauthorized detected on:", currentPath);

      // ❌ JANGAN redirect kalau di halaman public
      if (!isPublic) {
        localStorage.clear();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
